import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charging_package_settlements',
  component: Management,
  redirect: '/charging_package_settlements/list',
  children: [
    // 详情
    {
      path: ':id',
      component: () => import('@/views/charging_package_settlements/DetailLayout'),
      meta: {
        auth: Auth.showChargingPackageSettlement,
        activeMenu: '/ev_charging_station_settlements'
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/charging_package_settlements/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargingPackageSettlement,
            activeMenu: '/ev_charging_station_settlements'
          }
        }
      ]
    }
  ]
}
